import * as React from 'react'
import { Helmet } from 'react-helmet'

export default function Head ({
  title,
  description,
  image,
  ...props
}) {

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-us',
      }}>
      <meta charSet='utf-8' />
      <title>{title}</title>
      {description && <meta name='description' property='og:description' content={description} />}
      <meta property='og:title' content={title} />
      {image && <meta property='og:image' content={image.url} />}
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={title} />
      {description && <meta name='twitter:description' content={description} />}
      {image && <meta name='twitter:image' content={image.url} />}
    </Helmet>
  )
}
